// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3BXfk","noInteraction":"EventWrapper_noInteraction__2VxmM","pointerPassthrough":"EventWrapper_pointerPassthrough__1B__T"};